import { __decorate, __metadata } from "tslib";
import { appendStyle } from '@1inch-community/core/lit-utils';
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
let LoaderSpinnerElement = class LoaderSpinnerElement extends LitElement {
    constructor() {
        super(...arguments);
        this.size = 24;
        this.showLoader = true;
    }
    static { this.tagName = 'inch-loader-spinner'; }
    static { this.styles = css `
    :host {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      box-sizing: border-box;
      color: var(--color-content-content-tertiary);
    }

    .loader {
      position: absolute;
      cursor: wait;
      display: flex;
      width: calc(100% + 4px);
      height: calc(100% + 4px);
      box-sizing: border-box;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      border: 0.1em solid var(--secondary);
      z-index: 1;
    }

    .loader_animation {
      border-bottom-color: inherit;
      border-top-color: inherit;
      animation: spin 1s linear infinite;
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(360deg);
      }
    }
  `; }
    render() {
        appendStyle(this, {
            width: `${this.size}px`,
            height: `${this.size}px`,
        });
        const classes = {
            loader: true,
            loader_animation: this.showLoader,
        };
        return html `<div class="${classMap(classes)}"></div>
      <slot></slot>`;
    }
};
__decorate([
    property({ type: Number, attribute: true }),
    __metadata("design:type", Number)
], LoaderSpinnerElement.prototype, "size", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], LoaderSpinnerElement.prototype, "showLoader", void 0);
LoaderSpinnerElement = __decorate([
    customElement(LoaderSpinnerElement.tagName)
], LoaderSpinnerElement);
export { LoaderSpinnerElement };
//# sourceMappingURL=loader-spinner.element.js.map